import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { connect } from 'react-redux';
import { goToPage, reportDWH, setAdditionalMonths, setGuidId, setRemark, setCycleDate, setSelctedMonth, setSystemSourcePDF } from '../../PersonalAreaInvoicesSlice';
import { getHistoryPdfListAsync, getInvoiceDataAsync } from '../../PersonalAreaInvoicesAsyncThunk';
import { getMarketCode } from 'app/utilities/domain/domainConstants';

function HeaderDateMonths(props) {
  const invoicesDisplay = props.invoicesInfo?.filter(item => item.isViewPdf !== true)?.slice(-6)?.reverse();
  const moreInvoicesObg = props.invoicesInfo?.find(item => item.isViewPdf == true);
  // const [isMoreInvoices, setIsMoreInvoices] = useState(false);

  if(props.invoicesInfo?.length == 0){
    return null;
  };

  useEffect(()=>{
    setSelctedMonth(invoicesDisplay?.find(x => x.guidId === props.guidId));
  },[props.selctedMonth])

  const onClickMoreInvoices = async () => {
    window.scrollTo(0, 0);
    const data = {
      ban: moreInvoicesObg.ban,
      invoiceId: props.guidId,
      systemSource: getMarketCode(),
    };

    const result = await props.getHistoryPdfListAsync(data);
    if (result.payload.pdfs.length > 0) {
      props.setAdditionalMonths(true);
    };
  };

  const onClickMonth = (monthDetails, i) => {
    window.scrollTo(0, 0);
    const selectedInvoiceMonth = invoicesDisplay.find(item => item.guidId === monthDetails.guidId);
    if (selectedInvoiceMonth && selectedInvoiceMonth.guidId && selectedInvoiceMonth.guidId !== "") {
      props.setGuidId(selectedInvoiceMonth.guidId);
      props.setCycleDate(selectedInvoiceMonth.cycleDate);
      props.setSystemSourcePDF(selectedInvoiceMonth.systemSourcePDF);
      props.setRemark(null);
      getData();
    } else {
      props.setCycleDate(monthDetails.cycleDate);
      props.setRemark(<p>אין לך חשבוניות לחודש {monthDetails.cycleMonthName}</p>);
    };
    props.setAdditionalMonths(false);
    // setIsMoreInvoices(false);
  };

  function getData() {
    props.getInvoiceDataAsync();
  };


  return (
    <div className={`wrapper-swiper-months ${props.isSticky ? 'sticky' : ''} ${props.isAuthorizationHeader ? 'is-authenticated' : ''}`}>
      {invoicesDisplay?.length > 1 &&
        <div className='container-swiper-months'>
          <Swiper
            slidesPerView={'auto'}
            breakpoints={{
              220: {
                allowTouchMove: true,
              },
              1230: {
                allowTouchMove: false,
              },
            }}
          >
            {invoicesDisplay.map((monthDetails, i) => {
                  const title = props.isEnergy ? `${monthDetails?.periodMonthName} ${monthDetails?.cycleYear}` : `${monthDetails?.cycleMonthName} ${monthDetails?.cycleYear}`;
                  return(
                  <SwiperSlide
                      key={i}
                      onClick={() => onClickMonth(monthDetails,i)}
                      className={`${ props.indexMonth === i ? 'selected-month' : ''}`}>
                      <div className={`text-month ${ ( monthDetails.cycleDate === props.cycleDate)  && !props.isAdditionalMonths ? 'selected-month' : ''}`}>{title}</div>
                  </SwiperSlide>)
                }
              )
            }
            {moreInvoicesObg &&
              <SwiperSlide>
                <div className={`additional-months ${props.isAdditionalMonths ? 'purple-background' : ''}`} onClick={onClickMoreInvoices}>
                  <div>חשבוניות נוספות</div>
                </div>
              </SwiperSlide>
            }
          </Swiper>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    page: state.personalAreaInvoicesPage.page,
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo.history,
    guidId: state.personalAreaInvoicesPage.guidId,
    indexMonth: state.personalAreaInvoicesPage.indexMonth,
    historyPdfList: state.personalAreaInvoicesPage.historyPdfList,
    isAdditionalMonths: state.personalAreaInvoicesPage.isAdditionalMonths,
    cycleDate: state.personalAreaInvoicesPage.cycleDate,
    selctedMonth: state.personalAreaInvoicesPage.selctedMonth,
    isEnergy: state.personalAreaInvoicesPage.isEnergy
  };
};

const mapDispatchToProps = {
  setGuidId,
  reportDWH,
  setAdditionalMonths,
  getHistoryPdfListAsync,
  getInvoiceDataAsync,
  setRemark,
  setCycleDate,
  setSelctedMonth,
  setSystemSourcePDF
  // setIndexMonths
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderDateMonths);
